import { Navigate, useParams } from 'react-router-dom';

/** Redirection legacy /equipe/:memberId → vue 3 colonnes avec query member. */
export default function EquipeMember() {
  const { memberId } = useParams();
  const decoded = decodeURIComponent(memberId || '');
  return <Navigate to={`/equipe?member=${encodeURIComponent(decoded)}`} replace />;
}
